<div class="role-management-audit">
  <div *ngIf="rolesLoading">Loading...</div>

  <ng-container *ngIf="!rolesLoading">
    <mat-accordion *ngIf="roles.length; else noRoles" displayMode="flat">
      <mat-expansion-panel
        *ngFor="let role of roles; trackBy: roleTrackByFn"
        (opened)="selectRole(role)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>{{ role.name }}</mat-panel-title>
          <mat-panel-description [ngClass]="{ 'text-muted': !role.active }">
            {{ role.active ? 'Active' : 'Inactive' }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div *ngIf="selectedRole?.id === role.id" class="role-audit-logs">
            <div *ngIf="logsLoading">Loading...</div>

            <ng-container *ngIf="!logsLoading">
              <div *ngIf="logs.length; else noLogs">
                <div class="audit-log" *ngFor="let log of logs; trackBy: logTrackByFn">
                  <div class="audit-log-header">
                    <strong>{{ log.action }}</strong>
                    <span>by {{ log.performedBy }} on {{ log.time | date : 'short' }}</span>
                  </div>
                  <div *ngIf="log.fields?.length" class="audit-log-fields">
                    <div class="audit-log-field" *ngFor="let field of log.fields">
                      <span class="field-name">{{ field.name }}</span>
                      <span>{{ formatFieldValue(field, field.oldValue) }}</span>
                      <span>&rarr;</span>
                      <span>{{ formatFieldValue(field, field.newValue) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #noLogs>
                <em class="text-warning">No audit logs were found for this role</em>
              </ng-template>
            </ng-container>

            <sd-pagination
              *ngIf="logs.length"
              [dataSubscription]="logsPagination$"
              (paginationEvent)="onLogsPageChange($event)"
            ></sd-pagination>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-template #noRoles>
      <div class="text-center">
        <em class="text-warning">No roles were found</em>
      </div>
    </ng-template>
  </ng-container>

  <footer>
    <sd-pagination
      *ngIf="roles.length"
      [dataSubscription]="rolesPagination$"
      (paginationEvent)="onRolesPageChange($event)"
    ></sd-pagination>
  </footer>
</div>
